export default __webpack_public_path__ + "static/media/ticket.c6c83803.svg";